// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectDocumentType = function (x) {
    return x;
};
var tsBridgeProjectDocumentTy = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectDocumentType")("__brandProjectDocumentType"));
    }
};
var writeProjectDocumentType = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectDocumentType = Data_Show.showString;
var readProjectDocumentType = Simple_JSON.readString;
var ordProjectDocumentType = Data_Ord.ordString;
var newtypeProjectDocumentType = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectDocumentType = ProjectDocumentType;
var eqProjectDocumentType = Data_Eq.eqString;
export {
    ProjectDocumentType,
    makeProjectDocumentType,
    unwrap,
    newtypeProjectDocumentType,
    eqProjectDocumentType,
    ordProjectDocumentType,
    showProjectDocumentType,
    readProjectDocumentType,
    writeProjectDocumentType,
    tsBridgeProjectDocumentTy
};
//# sourceMappingURL=index.js.map
